import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
import VueAnalytics from "vue-analytics";
import camelCase from "lodash/camelCase";
import upperFirst from "lodash/upperFirst";
import Meta from "vue-meta";
import VueSession from 'vue-session';
import VueScrollTo from "vue-scrollto";
import * as VueGoogleMaps from 'vue2-google-maps';
import VueTelInput from 'vue-tel-input'
import VueTruncate from 'vue-truncate-filter'


import Router from 'vue-router'


import routes from './router'
 


var SocialSharing = require('vue-social-sharing');


const requireModal = require.context(
  './modals',
  false,
  /[A-Z]\w+\.(vue|js)$/
);

requireModal.keys().forEach(fileName => {
  const componentConfig = requireModal(fileName);

  const componentName = upperFirst(
    camelCase(
      fileName.replace(/^\.\/(.*)\.\w+$/, '$1')
    )
  );

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  );
});

Vue.use(Router);
Vue.use(SocialSharing);
Vue.use(VueTelInput);
Vue.use(Meta);
Vue.use(VueSession);
Vue.use(VueTruncate);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 });

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCO9A96Kiq8vUN9UhHsFAx_XAB8JMyEsHI',
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)
 
    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});

Vue.use(VueAnalytics, {
  id: 'UA-171670189-1', /* enter google analytics id here */
	router
});

Vue.config.productionTip = false;

const vueRouter = new Router({
  mode: "history",
  routes
});

vueRouter.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  window.scrollTo(0, 0);

  next()
})

new Vue({
  BootstrapVue,
  store,
  router: vueRouter,
  render: h => h(App)
}).$mount("#app");
